import { useQuery } from "@tanstack/react-query";

const CUSTOM_REAR_PRODUCT_ID =
  import.meta.env.VITE_SHOPIFY_CUSTOM_REAR_PRODUCT_ID || "10407582007588";

function buildQuery() {
  return `
        query @inContext(country: US) {
            product(id: "gid://shopify/Product/${CUSTOM_REAR_PRODUCT_ID}") {
                id
                title
                options {
                    id
                    name
                    optionValues {
                        name
                        id
                    }
                }
                variants(first: 100) {
                    edges {
                        node {
                            id
                            sku
                            title
                            selectedOptions {
                                name
                                value
                            }
                            priceV2 {
                                amount
                                currencyCode
                            }
                            compareAtPrice {
                                amount
                                currencyCode
                            }
                        }
                    }
                }
            }
        }
    `;
}

async function fetchCustomRearProduct() {
  const myHeaders = new Headers();
  myHeaders.append(
    "X-Shopify-Storefront-Access-Token",
    import.meta.env.VITE_SHOPIFY_STOREFRONT_TOKEN,
  );
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: buildQuery(),
    variables: {},
  });

  const response = await fetch(import.meta.env.VITE_SHOPIFY_STORE_URL, {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  });

  const data = await response.json();
  return data.data?.product || null;
}

export function useCustomRearProductQuery() {
  return useQuery({
    queryKey: ["customRearProduct"],
    queryFn: fetchCustomRearProduct,
    staleTime: 1000 * 60 * 30,
    retry: 1,
  });
}

export default function fetchCustomRearProductSync() {
  return fetchCustomRearProduct();
}
